import { renderDate, utils } from "@intrasync/utils";

import { makeAutoObservable, toJS } from "mobx";
import { RootStore, ServiceStore } from "@intrasync/stores";

interface Job {
  jobNumber: string;
  [key: string]: unknown;
}

// class JobStatsPanelCountStore {
//   entities: Job[] = [];
// }

class QrCodeStore {
  rootStore: RootStore;
  debugMode = false;
  enableReportComputedObservability = false;

  selectedPanelId: string | number | null = null;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this, { rootStore: false });
    this.rootStore = rootStore;
  }
  setSelectedPanelId = (value: string | number | null) => {
    this.selectedPanelId = value;
  };

  get title() {
    const params = this.rootStore.routerStore?.params;
    if (this.isDailyCastPage && params)
      return `Panels Casting ${renderDate(params.castingDate as string)}`;
    return this.currentJob ? `QR Codes` : "Loading...";
  }

  get currentJob() {
    const jobStore = this.rootStore.jobStore as ServiceStore;
    const routerStore = this.rootStore.routerStore;
    if (!routerStore) return undefined;
    if (!jobStore) return undefined;
    const { params } = routerStore;

    let job: Job | undefined;

    if (Array.isArray(jobStore.entities)) {
      job = (jobStore.entities as Job[]).find((j) =>
        utils.isSameJobNumber(j.jobNumber, params?.jobNumber as string)
      );
      // const jobStatsPanelCountStore = this.rootStore
      //   .jobStatsPanelCountStore as JobStatsPanelCountStore;

      // if (job && Array.isArray(jobStatsPanelCountStore.entities)) {
      //   const jobPanelStats = jobStatsPanelCountStore.entities.find(
      //     (stats: Job) => stats.jobNumber === params?.jobNumber
      //   );
      //   if (jobPanelStats) {
      //     job = { ...job, ...jobPanelStats };
      //   }
      // }
    }
    return job ? toJS(job) : null;
  }

  get currentSelectedPanel() {
    const routerStore = this.rootStore.routerStore;
    if (!routerStore) return undefined;

    const queryParams = routerStore.queryParams;
    if (!queryParams || !queryParams.dialogContext) return null;
    const panelStore = this.rootStore.panelStore as ServiceStore;
    const plantPanel = panelStore.entities.slice().find((p) => {
      return (
        queryParams?.dialogContext !== undefined &&
        String(p.controlUUID) === String(queryParams.dialogContext)
      );
    });

    if (!plantPanel) return null;
    // const panelStore = this.rootStore.panelStore as ServiceStore;

    const foundRevitPanel = panelStore.entities
      .slice()
      .find((p) => p.controlUUID === plantPanel.controlUUID);
    if (!foundRevitPanel) return plantPanel;

    return { ...plantPanel, ...foundRevitPanel };
  }

  get currentSelectedPanelJob() {
    if (!this.currentSelectedPanel?.jobNumber) return {};
    const jobStore = this.rootStore.jobStore as ServiceStore;
    if (!jobStore) return {};
    return jobStore.entities.find(
      (j) =>
        String(j.jobNumber) ===
        String(this.currentSelectedPanel?.jobNumber || "")
    );
  }
  get currentQRValue() {
    if (!this.currentSelectedPanel) return "Loading...";
    return `P-J${this.currentSelectedPanel.jobNumber}CN${this.currentSelectedPanel.controlNumber}`;
  }

  get isDailyCastPage() {
    const routerStore = this.rootStore.routerStore;
    if (!routerStore) return false;
    const currentPath = routerStore.currentPath as string;
    return currentPath.includes("daily-qr-codes");
  }

  get qrCodeRows() {
    if (!this.isDailyCastPage && !this.currentJob) return [];
    const panelStore = this.rootStore.panelStore as ServiceStore;
    const routerStore = this.rootStore.routerStore;
    if (!panelStore) return [];
    if (!routerStore) return [];

    if (this.isDailyCastPage)
      return panelStore.entities
        .slice()
        .filter((panel) => panel.castingDate === routerStore.params.castingDate)
        .map((item) => {
          return { ...item };
        });
    return panelStore.entities
      .slice()
      .filter((panel) => panel.jobNumber === routerStore.params.jobNumber)
      .map((item) => {
        return { ...item };
      });
  }
}

export default QrCodeStore;
